<div class="dashboard">
    <ng-container *ngFor="let item of itens">
        <div class="info">
            <div class="hgi-box" [ngClass]="item.estilo">
                <i class="hgi hgi-stroke" [ngClass]="item.icone"></i>
            </div>

            <div class="text">
                <span class="descricao">{{ item.descricao }}</span>
                <span class="quantidade">{{ item.quantidade }}</span>
            </div>
        </div>
    </ng-container>
    <div class="d-flex flex-column align-items-center justify-content-center">
        <custom-dropdown class="btn-filter mt-2" [label]="'Filtrar'" [image]="'../../../assets/img/icons/filter.svg'">
            <accordion [title]="'Data início'">
                <div class="input-group">
                    <i class="input-group-text hgi hgi-stroke hgi-calendar-04"></i>
                    <input id="dataInicio" type="date" class="custom-date-input" name="dataInicio"
                        [(ngModel)]="dataInicio" (change)="setDataInicio()" />
                </div>
            </accordion>
            <hr>
            <accordion [title]="'Data final'">
                <div class="input-group">
                    <i class="input-group-text hgi hgi-stroke hgi-calendar-04"></i>
                    <input id="dataFinal" type="date" class="custom-date-input" name="dataFinal" [(ngModel)]="dataFinal"
                        (change)="setDataFim()" />
                </div>
            </accordion>
            <button class="btn text-danger btn-limpar-filtro mt-2" (click)="limparFiltroStatus()">
                Limpar filtro
                <i class="fas fa-trash-alt ml-1"></i>
            </button>
        </custom-dropdown>
    </div>
</div>